/* Landing: anuncios rotativos, cuenta atrás, contadores, pestañas, carruseles, barra de stock y botones "ir a comprar". */
(function () {
  var ls = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };

  function onVisible(el, cb) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { io.disconnect(); cb(); } });
    }, { threshold: 0.3 });
    io.observe(el);
  }

  function initRotators(root) {
    root.querySelectorAll('[data-lc-rotate]:not([data-lc-ready])').forEach(function (el) {
      el.setAttribute('data-lc-ready', '');
      var items = el.querySelectorAll('.lc-ann__item');
      if (items.length < 2) return;
      var i = 0, speed = (parseInt(el.getAttribute('data-lc-rotate'), 10) || 4) * 1000;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed);
    });
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function initCountdowns(root) {
    root.querySelectorAll('[data-lc-countdown]:not([data-lc-ready])').forEach(function (el) {
      el.setAttribute('data-lc-ready', '');
      var mode = el.getAttribute('data-lc-countdown');
      var hours = parseFloat(el.getAttribute('data-hours')) || 6;
      var key = 'lc-cd-' + (el.getAttribute('data-key') || 'x');
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function end() {
        var now = Date.now();
        if (mode === 'midnight') { var d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime(); }
        var saved = parseInt(ls.get(key), 10);
        if (!saved || saved <= now) { saved = now + hours * 3600000; ls.set(key, saved); }
        return saved;
      }
      var target = end();
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) { target = end(); diff = target - Date.now(); }
        var t = Math.floor(diff / 1000);
        h.textContent = pad(Math.floor(t / 3600));
        m.textContent = pad(Math.floor((t % 3600) / 60));
        s.textContent = pad(t % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  function initCounters(root) {
    root.querySelectorAll('[data-lc-count]:not([data-lc-ready])').forEach(function (el) {
      el.setAttribute('data-lc-ready', '');
      var target = parseFloat(el.getAttribute('data-lc-count')) || 0;
      var from = parseFloat(el.getAttribute('data-from')) || 0;
      var dec = parseInt(el.getAttribute('data-decimals'), 10) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      var live = el.hasAttribute('data-live');
      function fmt(v) { return v.toLocaleString('es-ES', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suffix; }
      el.textContent = fmt(from);
      onVisible(el, function () {
        var t0 = null, dur = 2000;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var e = 1 - Math.pow(1 - p, 3);
          el.textContent = fmt(from + (target - from) * e);
          if (p < 1) { requestAnimationFrame(step); }
          else if (live) {
            var cur = target;
            setInterval(function () { cur += Math.floor(Math.random() * 3) + 1; el.textContent = fmt(cur); }, 3500);
          }
        }
        requestAnimationFrame(step);
      });
    });
    root.querySelectorAll('[data-lc-ring]:not([data-lc-ready])').forEach(function (el) {
      el.setAttribute('data-lc-ready', '');
      var pct = parseFloat(el.getAttribute('data-lc-ring')) || 0;
      onVisible(el, function () { el.style.strokeDashoffset = (226.2 * (1 - pct / 100)).toFixed(1); });
    });
    root.querySelectorAll('[data-lc-fill]:not([data-lc-ready])').forEach(function (el) {
      el.setAttribute('data-lc-ready', '');
      onVisible(el, function () { el.style.width = el.getAttribute('data-lc-fill') + '%'; });
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-lc-tabs]:not([data-lc-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-lc-ready', '');
      var btns = wrap.querySelectorAll('[data-lc-tab]');
      var panels = wrap.querySelectorAll('[data-lc-panel]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var i = b.getAttribute('data-lc-tab');
          btns.forEach(function (x) { x.classList.toggle('is-active', x === b); x.setAttribute('aria-selected', x === b); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-lc-panel') === i); });
        });
      });
    });
  }

  function initScrollers(root) {
    root.querySelectorAll('[data-lc-scroller]:not([data-lc-ready])').forEach(function (sc) {
      sc.setAttribute('data-lc-ready', '');
      var dots = sc.parentElement.querySelector('.lc-dots');
      if (!dots) return;
      var n = sc.children.length;
      dots.innerHTML = '';
      for (var i = 0; i < n; i++) dots.appendChild(document.createElement('span'));
      function upd() {
        var w = sc.children[0] ? sc.children[0].getBoundingClientRect().width + 12 : 1;
        var idx = Math.round(sc.scrollLeft / w);
        dots.querySelectorAll('span').forEach(function (d, j) { d.classList.toggle('is-active', j === Math.min(idx, n - 1)); });
      }
      sc.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
      upd();
    });
    root.querySelectorAll('[data-lc-expand]:not([data-lc-ready])').forEach(function (btn) {
      btn.setAttribute('data-lc-ready', '');
      btn.addEventListener('click', function () {
        var box = btn.closest('.lc-reviews');
        var open = box.classList.toggle('is-expanded');
        btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      });
    });
  }

  function initBuyLinks(root) {
    root.querySelectorAll('.lc-scroll-buy:not([data-lc-ready])').forEach(function (a) {
      a.setAttribute('data-lc-ready', '');
      a.addEventListener('click', function (e) {
        var target = (document.querySelector('#comprar .sv-packs') || document.querySelector('quantity-breaks, .product-form, product-info'));
        if (!target) return;
        e.preventDefault();
        var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }


  function initWalls(root) {
    root.querySelectorAll('[data-lc-wall-more]:not([data-lc-ready])').forEach(function (btn) {
      btn.setAttribute('data-lc-ready', '');
      btn.addEventListener('click', function () {
        var wall = btn.closest('.lc-wall');
        var open = wall.classList.toggle('is-open');
        btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
        if (!open) wall.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init(root) {
    root = root || document;
    initRotators(root); initCountdowns(root); initCounters(root);
    initTabs(root); initScrollers(root); initBuyLinks(root); initWalls(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
